// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="alert alert--danger">
    Any changes on this tab will take place immediately even without pushing the save or
    cancel button
    <button type="button" class="close" data-dismiss="alert">&times;</button>
  </div>

  <modal on-api-ready="\$ctrl.onDeactivateModalReady" form="\$ctrl.deactivateForm">
    <modal-header>
      <h2>Confirm device deactivation</h2>
    </modal-header>
    <modal-body>
      <ng-form name="\$ctrl.deactivateForm">
        <div class="labelled-field">
          <label>Remarks</label>
          <input ng-model="\$ctrl.deactivateRemarks" type="text" />
        </div>
      </ng-form>
    </modal-body>
  </modal>

  <dynamic-list
    columns="\$ctrl.columns"
    data="\$ctrl.agentDevices"
    sorting="\$ctrl.sorting">
  </dynamic-list>

  <div class="clearfix"></div>
</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/details/devices/agents-devices.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;